export const base64Encode =
  typeof Buffer !== 'undefined'
    ? (str: string): string => Buffer.from(str).toString('base64')
    : btoa;

export const base64Decode =
  typeof Buffer !== 'undefined'
    ? (bin: string): string => Buffer.from(bin, 'base64').toString()
    : atob;
